<template>
  <div class="edit-personal" :class="{ 'default_edit-personal': isDefault }">
    <el-scrollbar>
      <el-form
        class="edit-personal-form"
        :class="{
          showDownload: isBaozhi && isDefault,
          'edit-personal-form_height1': isPoster == 1 && isDefault,
          'edit-personal-form_height': ((loadPic == 1 && logo == 1) || decorationType == 'custom') && isDefault,
          'edit-personal-form_height2': isPoster == 1 && decorationType == 'custom' && isDefault
        }"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        :show-message="true"
      >
        <template>
          <div class="personal-item" v-if="!isPaper">
            <span class="personal-item-title">装订方式</span>
            <el-select class="personal-item-select" v-model="bookBinding" size="mini">
              <el-option label="左装订" :value="0"></el-option>
              <el-option label="右装订" :value="1"></el-option>
            </el-select>
            <el-tooltip placement="right" effect="light">
              <div slot="content">
                <p style="line-height: 28px">
                  修改装订方式将改变仿真阅读效果的翻页方向，常规中英文<br />现代出版物的装订方式为左装订，正序阅读翻页方向为从右<br />向左；中文古籍、维文等出版物的装订方式为右装订，正序<br />阅读翻页方向为从左向右。
                </p>
              </div>
              <div class="tooltips">?</div>
            </el-tooltip>
          </div>
          <div class="personal-item" :class="paperStyle == 1 && 'padding-63'">
            <span class="personal-item-title">开启音效 <span v-if="paperStyle" class="main-color">（仅移动端）</span></span>
            <eleRadio :isChecked="soundOn" @changeStatus="changeSoundStatus"></eleRadio>
          </div>
          <div class="personal-item" :class="paperStyle == 1 && 'padding-63'">
            <span class="personal-item-title">翻页音效<span v-if="paperStyle" class="main-color">（仅移动端）</span></span>
            <el-select class="personal-item-select" v-model="soundValue" size="mini">
              <el-option v-for="item in soundOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="personal-item">
            <span class="personal-item-title">朗读音效</span>
            <el-select class="personal-item-select" v-model="voiceNumber" @change="pauseAudio" size="mini">
              <el-option v-for="item in voiceOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-button class="read" @click="playVoice">▶&nbsp;试听</el-button>
            <audio ref="audio" controls="" style="display: none"></audio>
          </div>
          <div class="personal-item">
            <span class="personal-item-title">朗读语速</span>
            <el-select class="personal-item-select" v-model="voiceSpeed" size="mini">
              <el-option label="默认" :value="0"></el-option>
              <el-option label="慢" :value="1"></el-option>
              <el-option label="快" :value="2"></el-option>
              <el-option label="自定义" :value="3"></el-option>
            </el-select>
          </div>
          <div class="personal-item" v-if="voiceSpeed === 3">
            <span class="personal-item-title">自定义语速</span>
            <el-input v-model="userVoiceSpeed" class="personal-item-select voice" type="number" size="mini"></el-input>
          </div>
          <div class="personal-item" v-if="!isPaper">
            <div class="personal-item-title personal-vip-title">
              <span>分句朗读</span>
              <i class="vip">VIP</i>
            </div>
            <el-select class="personal-item-select" @change="changeOption('sentenceRead', 'sentenceRead')" v-model="sentenceRead" size="mini">
              <el-option label="关闭" :value="0"></el-option>
              <el-option label="打开" :value="1"></el-option>
            </el-select>
          </div>

          <div class="personal-item">
            <span class="personal-item-title">默认语言</span>
            <el-select class="personal-item-select" v-model="language" size="mini">
              <el-option label="中文" :value="0"></el-option>
              <el-option label="英文" :value="1"></el-option>
            </el-select>
          </div>

          <div class="personal-item">
            <span class="personal-item-title">按钮风格</span>
            <el-select class="personal-item-select" v-model="buttonValue" size="mini">
              <el-option v-for="item in buttonOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>

          <div class="personal-item">
            <div class="personal-item-title personal-vip-title">
              <span>显示功能</span>
              <i class="vip">VIP</i>
            </div>
            <div class="uploading" @click="showButtonSetting()">设置</div>
          </div>
          <div class="personal-item winEffect">
            <div class="personal-item-title">
              <span>窗口效果</span>
            </div>
            <div class="right">
              <el-select class="personal-item-select" v-model="winEffect" size="mini">
                <el-option :key="0" label="显示在版面上方" :value="0"></el-option>
                <el-option :key="1" label="和版面同层展示" :value="1"></el-option>
              </el-select>
            </div>
          </div>
          <div class="personal-item">
            <div class="personal-item-title personal-vip-title">
              <span>颜色设置</span>
              <i class="vip">VIP</i>
            </div>
            <el-select class="personal-item-select" @change="changeOption('colorSetting', 'colorSwitch')" v-model="colorSwitch" size="mini">
              <el-option :key="0" label="默认" :value="0"></el-option>
              <el-option :key="1" label="自定义" :value="1"></el-option>
            </el-select>
          </div>
          <div class="personal-item color-theme" v-show="colorSwitch === 1">
            <div class="personal-item-title">
              <span>PC端</span>
            </div>
            <div class="right">
              <div class="right-item">
                <span>导航栏颜色</span>
                <el-color-picker v-model="topNav"></el-color-picker>
              </div>
              <div class="right-item">
                <span>文字颜色</span>
                <el-color-picker v-model="topTxt"></el-color-picker>
              </div>
              <div class="right-item">
                <span>图标颜色</span>
                <el-select v-model="topIcon" size="mini">
                  <el-option :key="0" label="浅色" :value="0"></el-option>
                  <el-option :key="1" label="深色" :value="1"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="personal-item color-theme" v-show="colorSwitch === 1">
            <div class="personal-item-title">
              <span>移动端</span>
            </div>
            <div class="right">
              <div class="right-item">
                <span>导航栏颜色</span>
                <el-color-picker v-model="mobileNav"></el-color-picker>
              </div>
              <div class="right-item">
                <span>文字颜色</span>
                <el-color-picker v-model="mobileTxt"></el-color-picker>
              </div>
              <div class="right-item">
                <span>图标颜色</span>
                <el-select v-model="mobileIcon" size="mini">
                  <el-option :key="0" label="浅色" :value="0"></el-option>
                  <el-option :key="1" label="深色" :value="1"></el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div v-if="chargeOn && !isDefault" class="personal-item charge-page">
            <span class="personal-item-title">
              <span class="required">*</span>
              收费起始页
            </span>
            <div class="personal-item-content">
              <span>第</span>
              <el-form-item prop="chargePage"><el-input v-model.number="ruleForm.chargePage"></el-input></el-form-item>
              <span>页</span>
            </div>
          </div>
          <div v-if="!isDefault" class="personal-item loadPic">
            <div class="personal-item-title personal-vip-title">
              <span>加载图片</span>
              <i class="vip">VIP</i>
            </div>
            <div class="right">
              <div class="loadingSelect">
                <el-radio-group class="personal-item-select" :value="loadPic" size="mini" @change="changeLoading">
                  <el-radio v-for="item in loadingStyleOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
                </el-radio-group>
              </div>
              <div class="logoArea">
                <div class="uploadlogo" v-if="loadPic == 1">
                  <div class="upload">
                    <el-select class="personal-item-select pic-list" size="mini" v-model="loadingPic">
                      <el-option class="pic-list-item" v-for="(item, index) in privateLoadPic" :key="'loadPic' + index" :label="item.name" :value="item.path">
                        {{ item.name }}
                        <img class="select-del" src="@imgs/delete-gray.png" @click="delLoadPic(item, $event)" />
                      </el-option>
                    </el-select>
                    <label class="uploading" for="uploadpicButton" @click="uploadLoadingLogoButtonHandler($event)">上传</label>
                    <input type="file" id="uploadpicButton" ref="uploadPic" value="imgFile" accept="image/png, image/jpg" @change="uploadpicImg($event)" style="display: none" />
                  </div>
                  <div v-if="loadingPic && loadingPic != ''" class="thumbnail"><img :src="loadingPic" alt="" /></div>
                  <div class="thumbnail upload-tip" v-else>
                    <p>建议尺寸120*35</p>
                    <p>显示效果最佳</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!isDefault" class="personal-item checkUrl">
            <div class="personal-item-title personal-vip-title">
              <span>logo及url</span>
              <i class="vip">VIP</i>
            </div>
            <div class="right">
              <el-radio-group class="personal-item-select" :value="logo" size="mini" @change="changeType">
                <el-radio v-for="item in logoOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
              </el-radio-group>
              <div class="logoArea">
                <div class="uploadlogo" v-if="logo == 1">
                  <div v-if="paperStyle">
                    <div class="upload">
                      <div>pc端</div>
                      <el-select class="personal-item-select pic-list" size="mini" v-model="pcLogo">
                        <el-option @change="changePclogo" class="pic-list-item" v-for="(item, index) in privatePcLogoPic" :key="'loadPic' + index" :label="item.name" :value="item.path">
                          {{ item.name }}
                          <img class="select-del" src="@imgs/delete-gray.png" @click="delLoadPic(item, $event)" />
                        </el-option>
                      </el-select>
                      <label class="uploadlogoButton" for="uploadPclogoButton" @click="uploadLogoButtonHandler($event)">上传</label>
                      <input type="file" id="uploadPclogoButton" ref="upPclogo" value="imgFile" accept="image/png, image/jpeg, image/jpg" @change="uploadLogoImg($event, true)" style="display: none" />
                    </div>
                    <div v-if="pcLogo && pcLogo != ''" class="thumbnail"><img :src="pcLogo" alt="" /></div>
                    <div class="thumbnail upload-tip" v-else>
                      <p>建议尺寸400*60</p>
                      <p>显示效果最佳</p>
                    </div>
                  </div>
                  <div class="upload">
                    <div v-show="paperStyle">移动端</div>
                    <el-select class="personal-item-select pic-list" size="mini" v-model="logoThumbnail">
                      <el-option class="pic-list-item" v-for="(item, index) in privateLogoPic" :key="'loadPic' + index" :label="item.name" :value="item.path">
                        {{ item.name }}
                        <img class="select-del" src="@imgs/delete-gray.png" @click="delLoadPic(item, $event)" />
                      </el-option>
                    </el-select>
                    <label class="uploadlogoButton" for="uploadlogoButton" @click="uploadLogoButtonHandler($event)">上传</label>
                    <input type="file" id="uploadlogoButton" ref="uplogo" value="imgFile" accept="image/png, image/jpeg, image/jpg" @change="uploadLogoImg($event, false)" style="display: none" />
                  </div>
                  <div v-if="logoThumbnail && logoThumbnail != ''" class="thumbnail"><img :src="logoThumbnail" alt="" /></div>
                  <div class="thumbnail upload-tip" v-else>
                    <p>建议尺寸120*35</p>
                    <p>显示效果最佳</p>
                  </div>
                  <p>
                    <span>链接跳转 </span>
                    <el-select class="personal-item-select" size="mini" v-model="logoUrlOpen" @change="changeUrlOpen">
                      <el-option label="开启" :value="1" />
                      <el-option label="不开启" :value="0" />
                    </el-select>
                  </p>
                  <p class="logoUrlTxt">点击logo跳转地址：</p>
                  <el-input v-model="logoUrl" v-if="logo == 1" :disabled="logoDisabled || this.logoUrlOpen === 0"></el-input>
                </div>
              </div>
            </div>
          </div>
          <div class="personal-item flex-start" v-if="(!isBaozhi && isDefault) || (!isDefault && !isPaper)">
            <div class="personal-item-title personal-vip-title">
              <span>封面装饰</span>
              <i class="vip">VIP</i>
            </div>
            <EditAdorn class="edit-personal-adorn" :decoration="adornment" :size="'mini'" @signTypeChange="changeDecoration" @adornmentMsn="adornmentMsn"></EditAdorn>
          </div>
          <!-- 是否开启海报 -->
          <div class="default-poster">
            <div class="personal-item poster">
              <div class="personal-item-title personal-vip-title">
                <span>开启海报</span>
                <i class="vip">VIP</i>
              </div>
              <div class="right">
                <el-select class="personal-item-select" size="mini" v-model="isPoster" @change="changePosterType">
                  <el-option v-for="item in posterOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <!-- 选择海报风格 -->
            <div class="personal-item posterStyle" v-if="isPoster === 1">
              <div class="personal-item-title personal-vip-title">
                <span>海报风格</span>
                <i class="vip">VIP</i>
              </div>
              <div class="right">
                <el-select class="personal-item-select" size="mini" v-model="selPoster" @change="changePosterStyle">
                  <el-option v-for="item in posterStyleOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <div class="customSec" v-if="selPoster === 1 && customTit">
                  <span class="customTit">{{ customTit }}</span>
                  <button type="button" @click="replaceCus($event)">替换</button>
                </div>
              </div>
            </div>
          </div>
          <!-- 是否开启分享文章带版面图 -->
          <div class="default-poster" v-if="isPaper">
            <div class="personal-item poster">
              <div class="personal-item-title personal-vip-title">
                <span>分享文章带版面图</span>
              </div>
              <div class="right">
                <el-select class="personal-item-select" size="mini" v-model="articleLayout">
                  <el-option v-for="item in articleLayoutOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <!-- 文章区域高亮显示 -->
            <div class="personal-item posterStyle" v-if="articleLayout === 1">
              <div class="personal-item-title personal-vip-title">
                <span>文章区域高亮显示</span>
              </div>
              <div class="right">
                <el-select class="personal-item-select" size="mini" v-model="articleHighlight">
                  <el-option v-for="item in articleLayoutOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div v-if="isBaozhi" class="personal-item openDownload">
            <div class="personal-item-title personal-vip-title">
              <span>文件下载</span>
              <i class="vip">VIP</i>
            </div>
            <div class="right">
              <el-select class="personal-item-select" size="mini" v-model="downloadValue" @change="changeDownload">
                <el-option v-for="item in downloadOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <div class="downloadSel" v-show="downloadValue == 1 || downloadValue == 2">
                <div class="species">
                  <eleRadio :isChecked="pdfStatus" @changeStatus="changeDownloadFormat('pdf')"></eleRadio>
                  <span>PDF</span>
                </div>
                <div class="species">
                  <eleRadio :isChecked="zipStatus" @changeStatus="changeDownloadFormat('zip')"></eleRadio>
                  <span>HTML</span>
                </div>
                <div class="species" v-if="readModel == 2 && !isPaper && !paperStyle">
                  <eleRadio :isChecked="epubStatus" @changeStatus="changeDownloadFormat('epub')"></eleRadio>
                  <span>EPUB</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!isDefault" class="personal-item posterStyle">
            <div class="personal-item-title personal-vip-title">
              <span>背景音乐</span>
              <i class="vip">VIP</i>
            </div>
            <div class="right">
              <el-select class="personal-item-select" v-model="bgMusic" size="mini" @change="changeBgMusic">
                <el-option v-for="item in bgMusicOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <div class="customSec" v-if="bgMusic === 1">
                <label class="uploadAudioBut" for="uploadAudioButton" @click="uploadAudioButtonHandler($event)"><img src="@imgs/add-audio.png" alt=""/></label>
                <input type="file" id="uploadAudioButton" value="audioFile" accept="audio/mpeg" @change="uploadAudio($event)" style="display: none;" />
                <div class="audio-name" :title="audioFileName">{{ audioFileName }}</div>
              </div>
            </div>
          </div>
          <div class="personal-item poster" v-if="bgMusic === 1">
            <span class="personal-item-title">循环播放</span>
            <div class="right">
              <el-select class="personal-item-select" v-model="circulatePlay" size="mini" @change="bgMusicIsLoop">
                <el-option v-for="item in circulatePlayOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
          </div>
          <div v-if="false" class="personal-item">
            <span class="personal-item-title">自动翻页</span>
            <el-select class="personal-item-select" v-model="flip" size="mini" @change="changeFlip">
              <el-option v-for="item in flipOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="personal-item" v-if="false">
            <div>
              <span class="personal-item-title">间隔时间</span>
              <input type="number" v-model="pageTurnInterval" placeholder="可输入3-999正整数" class="inputTime" />
              秒
            </div>
          </div>
          <div class="personal-item long-press">
            <div class="personal-item-title">
              <span>长按识别</span>
            </div>
            <div class="right">
              <el-select class="personal-item-select" size="mini" v-model="longPress">
                <el-option label="关闭" :value="0"></el-option>
                <el-option label="开启" :value="1"></el-option>
              </el-select>
            </div>
            <el-tooltip placement="right" effect="light">
              <div slot="content">
                <p>开启“长按识别”，在移动端阅读作品时，长按可识别页面上的二维码，也可保存版面图片。</p>
                <p>关闭“长按识别”，在移动端阅读作品时，长按无法识别二维码也不会保存版面图片。</p>
                <p>如需跳转页面查看更多内容，可前往数字内容编辑，添加超链接。</p>
              </div>
              <div class="tooltips">?</div>
            </el-tooltip>
          </div>
          <div class="personal-item long-press">
            <div class="personal-item-title">
              <span>文章文本复制</span>
            </div>
            <div class="right">
              <el-select class="personal-item-select" size="mini" v-model="copyText">
                <el-option label="关闭" :value="0"></el-option>
                <el-option label="开启" :value="1"></el-option>
              </el-select>
            </div>
          </div>
        </template>
        <div v-if="isDefault">
          <div class="personal-item loadPic">
            <div class="personal-item-title personal-vip-title">
              <span>加载图片</span>
              <i class="vip">VIP</i>
            </div>
            <div class="right">
              <div class="loadingSelect">
                <el-radio-group class="personal-item-select" :value="loadPic" size="mini" @change="changeLoading">
                  <el-radio v-for="item in loadingStyleOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
                </el-radio-group>
              </div>
              <div class="logoArea">
                <div class="uploadlogo" v-if="loadPic == 1">
                  <div class="upload">
                    <span>移动端</span>
                    <el-select class="personal-item-select pic-list" size="mini" v-model="loadingPic">
                      <el-option class="pic-list-item" v-for="(item, index) in privateLoadPic" :key="'loadPic' + index" :label="item.name" :value="item.path">
                        {{ item.name }}
                        <img class="select-del" src="@imgs/delete-gray.png" @click="delLoadPic(item, $event)" />
                      </el-option>
                    </el-select>
                    <label class="uploading" for="uploadpicButton" @click="uploadLoadingLogoButtonHandler($event)">上传</label>
                    <input type="file" id="uploadpicButton" ref="uploadPic" value="imgFile" accept="image/png, image/jpg" @change="uploadpicImg($event)" style="display: none" />
                  </div>
                  <div v-if="loadingPic && loadingPic != ''" class="thumbnail"><img :src="loadingPic" alt="" /></div>
                  <div class="thumbnail upload-tip" v-else>
                    <p>建议尺寸{{ paperStyle ? '400x60' : '120*35' }}</p>
                    <p>显示效果最佳</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="personal-item checkUrl">
            <div class="personal-item-title personal-vip-title">
              <span>logo及url</span>
              <i class="vip">VIP</i>
            </div>
            <div class="right">
              <el-radio-group class="personal-item-select" :value="logo" size="mini" @change="changeType">
                <el-radio v-for="item in logoOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
              </el-radio-group>
              <div class="logoArea">
                <div class="uploadlogo" v-if="logo == 1">
                  <div v-if="paperStyle">
                    <div class="upload">
                      <div>pc端</div>
                      <el-select class="personal-item-select pic-list" size="mini" v-model="pcLogo">
                        <el-option @change="changePclogo" class="pic-list-item" v-for="(item, index) in privatePcLogoPic" :key="'loadPic' + index" :label="item.name" :value="item.path">
                          {{ item.name }}
                          <img class="select-del" src="@imgs/delete-gray.png" @click="delLoadPic(item, $event)" />
                        </el-option>
                      </el-select>
                      <label class="uploadlogoButton" for="uploadPclogoButton" @click="uploadLogoButtonHandler($event)">上传</label>
                      <input type="file" id="uploadPclogoButton" ref="upPclogo" value="imgFile" accept="image/png, image/jpeg, image/jpg" @change="uploadLogoImg($event, true)" style="display: none" />
                    </div>
                    <div v-if="pcLogo && pcLogo != ''" class="thumbnail"><img :src="pcLogo" alt="" /></div>
                    <div class="thumbnail upload-tip" v-else>
                      <p>建议尺寸400*60</p>
                      <p>显示效果最佳</p>
                    </div>
                  </div>
                  <div class="upload">
                    <div v-show="paperStyle">移动端</div>
                    <el-select class="personal-item-select pic-list" size="mini" v-model="logoThumbnail">
                      <el-option class="pic-list-item" v-for="(item, index) in privateLogoPic" :key="'loadPic' + index" :label="item.name" :value="item.path">
                        {{ item.name }}
                        <img class="select-del" src="@imgs/delete-gray.png" @click="delLoadPic(item, $event)" />
                      </el-option>
                    </el-select>
                    <label class="uploadlogoButton" for="uploadlogoButton" @click="uploadLogoButtonHandler($event)">上传</label>
                    <input type="file" id="uploadlogoButton" ref="uplogo" value="imgFile" accept="image/png, image/jpeg, image/jpg" @change="uploadLogoImg($event)" style="display: none" />
                  </div>
                  <div v-if="logoThumbnail && logoThumbnail != ''" class="thumbnail"><img :src="logoThumbnail" alt="" /></div>
                  <div class="thumbnail upload-tip" v-else>
                    <p>建议尺寸120*35</p>
                    <p>显示效果最佳</p>
                  </div>
                  <p>
                    <span>链接跳转 </span>
                    <el-select class="personal-item-select" size="mini" v-model="logoUrlOpen" @change="changeUrlOpen">
                      <el-option label="开启" :value="1" />
                      <el-option label="不开启" :value="0" />
                    </el-select>
                  </p>
                  <p class="logoUrlTxt">点击logo跳转地址：</p>
                  <el-input v-model="logoUrl" v-if="logo == 1" :disabled="logoDisabled || this.logoUrlOpen === 0"></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="personal-item openDownload">
          <div class="personal-item-title personal-vip-title">
            <span>移动端导航栏</span>
          </div>
          <div class="right">
            <el-select class="personal-item-select" size="mini" v-model="navbarSwtich">
              <el-option :key="0" label="默认自动收起" :value="0"></el-option>
              <el-option :key="1" label="默认固定显示" :value="1"></el-option>
            </el-select>
          </div>
        </div>
        <div v-if="isPaper">
          <div class="personal-item openDownload">
            <div class="personal-item-title personal-vip-title">
              <span>历史资源入口</span>
            </div>
            <div class="right">
              <el-select class="personal-item-select" size="mini" v-model="historyResource">
                <el-option :key="1" label="开启" :value="1"></el-option>
                <el-option :key="0" label="关闭" :value="0"></el-option>
              </el-select>
            </div>
          </div>
          <div class="personal-item checkUrl" v-if="historyResource">
            <div class="personal-item-title ">
              <span>入口名称</span>
            </div>
            <div class="right">
              <el-input v-model="entryName" placeholder="请输入名称"></el-input>
            </div>
          </div>
          <div class="personal-item checkUrl" v-if="historyResource">
            <div class="personal-item-title ">
              <span>入口地址</span>
            </div>
            <div class="right">
              <el-input v-model="entryUrl" placeholder="请输入地址"></el-input>
            </div>
          </div>
          <div class="personal-item openDownload">
            <div class="personal-item-title personal-vip-title">
              <span>官方主页</span>
            </div>
            <div class="right">
              <el-select class="personal-item-select" size="mini" v-model="officialWeb">
                <el-option :key="1" label="开启" :value="1"></el-option>
                <el-option :key="0" label="关闭" :value="0"></el-option>
              </el-select>
            </div>
          </div>
          <div class="personal-item checkUrl" v-if="officialWeb">
            <div class="personal-item-title ">
              <span>主页名称</span>
            </div>
            <div class="right">
              <el-input v-model="homePageTitle" placeholder="请输入名称"></el-input>
            </div>
          </div>
          <div class="personal-item checkUrl" v-if="officialWeb">
            <div class="personal-item-title">
              <span>主页地址</span>
            </div>
            <div class="right">
              <el-input v-model="homePageUrl" placeholder="请输入地址"></el-input>
            </div>
          </div>
        </div>
        <div v-if="!isDefault" class="personal-item">
          <span class="personal-item-title">听文章样式</span>
          <el-select class="personal-item-select" v-model="listenStyle" size="mini">
            <el-option label="报纸" :value="0"></el-option>
            <el-option label="书刊" :value="1"></el-option>
          </el-select>
        </div>
      </el-form>
    </el-scrollbar>
    <button-set ref="buttonSet" :is-paper="isPaper"></button-set>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions" :appendToBody="true"></tip-dialog>
    <TipDialog ref="deleteDialog" :dialogOptions="deleteDialogOptions" @clickCancel="deleteCancel" @clickConfirm="deleteConfrim" :appendToBody="true"></TipDialog>
    <LogoCropDialog ref="Logocrop" :imgName="logoImaName" :cropImgUrl.sync="cropImgUrl" @cropConfirm="cropConfirm"></LogoCropDialog>
    <CustomPos ref="custompos" :qrObj="qrObj" @getCustomTit="getCustomTit" @getCusImg="getCusImg"></CustomPos>
  </div>
</template>
<script>
import eleRadio from '@components/common/Radio.vue'
import TipDialog from '@components/common/TipDialog.vue'
import BookMsn from '@api/getBook'
import setBook from '@api/setBook'
import { getDefaultSetting } from '@api/setBook'
import LogoCropDialog from './LogoCropDialog'
import CustomPos from '@components/poster/customPos.vue'
import EditAdorn from '@components/commonEdit/editAdorn'
import { isPureNum } from '@/utils'
import compareVipRight from '@components/common/compareVipRight.js'
import paperApi from '@api/paperManager'
import ButtonSet from './ButtonSet'

export default {
  name: 'editPersonal',
  data() {
    var checkPrice = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('不能为空'))
      }
      setTimeout(() => {
        if (isNaN(value)) {
          callback(new Error('请输入数字'))
        } else {
          if (value > 999 || value < 1) {
            callback(new Error('需在1-999之间'))
          } else {
            callback()
          }
        }
      }, 10)
    }
    var checkPage = (rule, value, callback) => {
      if (!value && value !== 0) {
        return callback(new Error('不能为空'))
      }
      setTimeout(() => {
        if (isNaN(value)) {
          callback(new Error('请输入数字'))
        } else {
          if (value < 1) {
            callback(new Error('需大于1'))
          } else {
            callback()
          }
        }
      }, 10)
    }
    return {
      adornment: '', //装饰
      catalogOn: true,
      chargeOn: false,
      loadingStyleText: true,
      rules: {
        loadingText: [{ required: true, message: '不能为空' }],
        price: [{ validator: checkPrice, trigger: 'blur' }],
        chargePage: [{ validator: checkPage, trigger: 'blur' }]
      },
      buttonOptions: [
        {
          value: 0,
          label: '图标'
        },
        {
          value: 1,
          label: '文字'
        }
      ],
      soundOptions: [
        {
          value: 0,
          label: '默认'
        },
        {
          value: 1,
          label: '厚重'
        },
        {
          value: 2,
          label: '轻柔'
        }
      ],
      loadingStyleOptions: [
        {
          value: 0,
          label: '默认'
        },
        {
          value: 1,
          label: '自定义'
        }
      ],
      logoOptions: [
        {
          value: 0,
          label: '默认'
        },
        {
          value: 1,
          label: '自定义'
        }
      ],
      posterOptions: [
        {
          value: 0,
          label: '否'
        },
        {
          value: 1,
          label: '是'
        }
      ],
      articleLayoutOptions: [
        {
          value: 0,
          label: '关闭'
        },
        {
          value: 1,
          label: '开启'
        }
      ],
      posterStyleOptions: [
        {
          value: 0,
          label: '默认风格'
        },
        {
          value: 1,
          label: '自定义'
        }
      ],
      flipOptions: [
        {
          value: 0,
          label: '关闭'
        },
        {
          value: 1,
          label: '开启'
        }
      ],
      deleteDialogOptions: {
        // 弹框类型
        type: 'delete',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '是否确认删除？'
      },
      lastDownloadValue: 0,
      downloadValue: 0, //默认关闭下载
      isPoster: 0, //默认不开启海报
      selPoster: 0, //默认状态 默认风格
      articleLayout: 0, //// 分享文章是否带版面图，默认0；0-否，1-是
      articleHighlight: 0, //[版面图中]文章区域是否高亮，默认0；0-否，1-是
      customTit: '',
      flip: 0, //默认关闭
      pageTurnInterval: '', //自动翻页设置时间
      logo: 0, //默认
      loadPic: 0, //默认方正加载图片logo
      privateLoadPic: [], //自定义上传加载图
      privateLogoPic: [], //自定义上传logo
      privatePcLogoPic: [], //pc自定义上传logo
      loadTab: false, //默认方正logo
      logoUrl: `${window.PROJECT_CONFIG.BASE_URL}/elecPublish/`,
      uploadLogo: false,
      cropImgUrl: '',
      logoImaName: '',
      vuexModuleName: 'UPDATE_LOGOTHUMBNAI',
      custompos: false,
      qrObj: {
        value: window.location.href.replace('book', 'content')
      },
      cusImg: '',
      pdfStatus: false,
      zipStatus: false,
      epubStatus: false,
      readModel: 0,
      formatList: [],
      bgMusicOptions: [
        {
          value: 0,
          label: '关闭'
        },
        {
          value: 1,
          label: '开启'
        }
      ],
      circulatePlayOptions: [
        {
          value: 0,
          label: '否'
        },
        {
          value: 1,
          label: '是'
        }
      ],
      voiceOption: [
        { label: '小管', value: 1 },
        { label: '小颖', value: 2 },
        { label: '小万', value: 3 },
        { label: '小燕', value: 4 },
        { label: '小许', value: 5 },
        { label: '小萍', value: 6 },
        { label: '小婧', value: 7 }
      ],
      bgMusic: 0,
      circulatePlay: 0,
      audioFileName: '',
      audioFile: null,
      deletePic: null,
      decorationType: '',
      allHeight: 0
      // isPaper: this.$route.path.indexOf('paper') > -1
      // homePageUrl: '',
      // homePageTitle: ''
    }
  },
  props: {
    isDefault: {
      type: Boolean,
      default: false
    },
    isBaozhi: {
      type: Boolean,
      default: true
    },
    paperObj: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  mixins: [compareVipRight],
  computed: {
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    },
    logoDisabled() {
      return !(this.compare({ type: 'boole', key: 'replaceBookLogo' }) && this.compare({ type: 'boole', key: 'replaceLogoLink' }))
    },
    loadingLogoDisabled() {
      return !this.compare({ type: 'boole', key: 'replaceLoadingLogo' })
    },
    soundOn: {
      get: function() {
        return this.$store.state.config.bookObj.soundOn
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_SOUND', value)
      }
    },
    logoUrlOpen: {
      get: function() {
        return this.$store.state.config.bookObj.logoUrlOpen
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_LOGOURL_OPEN', value)
      }
    },
    longPress: {
      get: function() {
        return this.$store.state.config.bookObj.longPress
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_LONG_PRESS', value)
      }
    },
    copyText: {
      get: function() {
        return this.$store.state.config.bookObj.copyText
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_BOOK_ITEM', { name: 'copyText', val: value })
      }
    },
    navbarSwtich: {
      get: function() {
        return this.$store.state.config.bookObj.navbarSwtich
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_NAVBAR_SWITCH', value)
      }
    },
    officialWeb: {
      get: function() {
        return this.$store.state.config.bookObj.officialWeb
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_OFFICIALWEB', value)
      }
    },
    homePageTitle: {
      get: function() {
        return this.$store.state.config.bookObj.homePageTitle
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_HOMEPAGE_TITLE', value)
      }
    },
    homePageUrl: {
      get: function() {
        return this.$store.state.config.bookObj.homePageUrl
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_HOMEPAGE_URL', value)
      }
    },
    historyResource: {
      get: function() {
        return this.$store.state.config.bookObj.historyResource
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_HISTORY_RESOURCE', value)
      }
    },
    entryName: {
      get: function() {
        return this.$store.state.config.bookObj.entryName
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_ENTRY_NAME', value)
      }
    },
    entryUrl: {
      get: function() {
        return this.$store.state.config.bookObj.entryUrl
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_ENTRY_URL', value)
      }
    },
    buttonValue: {
      get: function() {
        return this.$store.state.config.bookObj.buttonStyle
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_BUTTON', value)
      }
    },
    winEffect: {
      get: function() {
        return this.$store.state.config.bookObj.winEffect
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_WIN_EFFECT', value)
      }
    },
    bookBinding: {
      get: function() {
        return this.$store.state.config.bookObj.bookBinding
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_BOOKBINDING', value)
      }
    },
    colorSwitch: {
      get: function() {
        return this.$store.state.config.bookObj.colorSwitch
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_COLOR_SWITCH', value)
      }
    },
    colorContent: {
      get: function() {
        return this.$store.state.config.bookObj.colorContent
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_COLOR_CONTENT', value)
      }
    },
    topNav: {
      get: function() {
        return this.$store.state.config.bookObj.colorContent['top-nav']
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_COLOR_CONTENT_ITEM', { value: value, name: 'top-nav' })
      }
    },
    topTxt: {
      get: function() {
        return this.$store.state.config.bookObj.colorContent['top-txt']
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_COLOR_CONTENT_ITEM', { value: value, name: 'top-txt' })
      }
    },
    topIcon: {
      get: function() {
        return this.$store.state.config.bookObj.colorContent['top-icon']
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_COLOR_CONTENT_ITEM', { value: value, name: 'top-icon' })
      }
    },
    mobileNav: {
      get: function() {
        return this.$store.state.config.bookObj.colorContent['mobile-nav']
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_COLOR_CONTENT_ITEM', { value: value, name: 'mobile-nav' })
      }
    },
    mobileTxt: {
      get: function() {
        return this.$store.state.config.bookObj.colorContent['mobile-txt']
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_COLOR_CONTENT_ITEM', { value: value, name: 'mobile-txt' })
      }
    },
    mobileIcon: {
      get: function() {
        return this.$store.state.config.bookObj.colorContent['mobile-icon']
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_COLOR_CONTENT_ITEM', { value: value, name: 'mobile-icon' })
      }
    },
    soundValue: {
      get: function() {
        return this.$store.state.config.bookObj.soundId
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_SOUND_ID', value)
      }
    },
    voiceNumber: {
      get: function() {
        return this.$store.state.config.bookObj.voiceNumber
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_VOICE_NUMBER', value)
      }
    },
    language: {
      get: function() {
        return this.$store.state.config.bookObj.language
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_LANGUAGE', value)
      }
    },
    voiceSpeed: {
      get: function() {
        return this.$store.state.config.bookObj.voiceSpeed
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_BOOK_ITEM', { name: 'voiceSpeed', val: value })
      }
    },
    userVoiceSpeed: {
      get: function() {
        return this.$store.state.config.bookObj.userVoiceSpeed
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_BOOK_ITEM', { name: 'userVoiceSpeed', val: value })
      }
    },
    sentenceRead: {
      get: function() {
        return this.$store.state.config.bookObj.sentenceRead
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_BOOK_ITEM', { name: 'sentenceRead', val: value })
      }
    },
    loadingStyle: {
      get: function() {
        return this.$store.state.config.bookObj.loadingId
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_LOADING_ID', value)
      }
    },
    loadingColor: {
      get: function() {
        return this.$store.state.config.bookObj.loadingColor
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_LOADING_COLOR', value)
      }
    },
    ruleForm: {
      get: function() {
        return this.$store.state.config.bookObj.ruleForm
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_RULE_FORM', value)
      }
    },
    userName() {
      return localStorage.getItem('username')
    },
    logoThumbnail: {
      get: function() {
        return this.$store.state.config.logoThumbnail
      },
      set: function(newValue) {
        this.$store.commit('config/UPDATE_LOGOTHUMBNAIL', newValue)
      }
    },
    pcLogo: {
      get: function() {
        return this.$store.state.config.pcLogo
      },
      set: function(newValue) {
        this.$store.commit('config/UPDATE_PCLOGO', newValue)
      }
    },
    isPaper() {
      return this.$store.state.book.isPaper
    },
    loadingPic: {
      get: function() {
        return this.$store.state.config.book.loadingPic
      },
      set: function(newVal) {
        this.$store.commit('config/UPDATE_LOADINGPIC', newVal)
      }
    },
    listenStyle: {
      get: function() {
        return this.$store.state.config.bookObj.listenStyle
      },
      set: function(newVal) {
        this.$store.commit('config/UPDATE_BOOK_ITEM', { name: 'listenStyle', val: newVal })
      }
    },
    downloadOptions: {
      get() {
        return [
          {
            value: 0,
            label: '不开放下载'
          },
          {
            value: 1,
            label: this.isPaper || this.isDefault ? '仅通过“我的数字报”下载' : '仅通过“我的书刊”下载'
          },
          {
            value: 2,
            label: '开放读者阅读时下载'
          }
        ]
      }
    },
    isShowCommerHeader() {
      return this.$store.state.book.isShowCommerHeader
    },
    getQueryId() {
      return isPureNum(this.$route.query.id)
    },
    paperStyle() {
      return this.$store.state.config.paperStyle
    }
  },
  methods: {
    toMember() {
      this.$refs.memberDialog.visible = true
    },
    changeSoundStatus() {
      this.soundOn = !this.soundOn
    },
    changeChargeStatus() {
      this.chargeOn = !this.chargeOn
    },
    changeCatalogStatus() {
      this.catalogOn = !this.catalogOn
    },
    changeLoadingStyle() {
      this.loadingStyleText = !this.loadingStyleText
    },
    showButtonSetting() {
      if (this.compare({ type: 'boole', key: 'displaySet' })) {
        this.$refs.buttonSet.dialogVisible = true
      } else {
        this.$refs.memberDialog.visible = true
      }
    },
    changeOption(key, param) {
      if (!this.compare({ type: 'boole', key: key })) {
        this.$refs.memberDialog.visible = true
        this[param] = 0
      }
    },
    async changeLoading(value) {
      if (value == 0) {
        if (!(await this.compareRight({ type: 'boole', key: 'replaceLoadingLogo' }))) {
          this.toMember()
          this.loadPic = 0
        } else {
          this.getImage('loadPic')
          this.loadPic = 1
        }
      } else {
        this.loadPic = 0
        this.$store.commit('config/UPDATE_LOADINGPIC', '')
      }
    },
    async changePosterType(value) {
      if (value == 1) {
        if (!(await this.compareRight({ type: 'boole', key: 'poster' }))) {
          this.toMember()
          this.isPoster = 0
        }
      }
    },
    async changePosterStyle(value) {
      if (await this.compareRight({ type: 'boole', key: 'poster' })) {
        if (value == 1) {
          this.$refs.custompos.dialogVisible = true
        }
      } else {
        this.$refs.memberDialog.visible = true
        this.selPoster = value === 1 ? 0 : 1
      }
    },
    async replaceCus(e) {
      if (!(await this.compareRight({ type: 'boole', key: 'poster' }))) {
        this.toMember()
      } else {
        this.$nextTick(() => {
          this.$refs.custompos.dialogVisible = true
        })
      }
    },
    async changeFlip(value) {
      if (value == 1) {
        const isMember = await this.$store.dispatch('common/getVipInfo')
        if (isMember == false) {
          this.$refs.memberDialog.visible = true
          this.flip = 0
        }
      }
    },
    check() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('checkcallback', true)
        } else {
          this.$emit('checkcallback', false)
          return false
        }
      })
    },
    adornmentMsn(value) {
      this.$emit('adornmentMsn', value)
    },
    changeDecoration(value) {
      this.decorationType = value
    },
    uploadLogoImg(e, type) {
      var _this = this
      //上传图片
      var file = e.target.files[0]
      this.logoImaName = file.name
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        return false
      }
      let imgFile = new FileReader()
      imgFile.readAsDataURL(file)
      imgFile.onload = (res) => {
        _this.cropImgUrl = res.target.result
        _this.$refs.uplogo.value = ''
        _this.$refs.Logocrop.dialogVisible = true
        _this.$refs.Logocrop.ispclogo = type
        _this.$nextTick(() => {
          _this.uploadLogo = true
          _this.$refs.Logocrop.init()
        })
      }
    },
    async cropConfirm(type) {
      if (type) {
        // pclogo
        await this.getImage('pcLogo')
        this.pcLogo = this.privatePcLogoPic[0].path
        this.$store.commit('config/UPDATE_PCLOGO', this.pcLogo)
      } else {
        await this.getImage('logo')
        this.logoThumbnail = this.privateLogoPic[0].path
      }
    },
    uploadpicImg(e) {
      var _this = this
      //上传图片
      var file = e.target.files[0]
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        return false
      }
      let params = new FormData()
      params.append('fieldName', 'loadPic')
      params.append('loadPic', file)
      setBook.uploadPicture(params).then(async (res) => {
        if (res.status === 200 && res.data.code === 0) {
          await _this.getImage('loadPic')
          _this.loadTab = true
          _this.$refs.uploadPic.value = ''
          _this.$store.commit('config/UPDATE_LOADINGPIC', _this.privateLoadPic[0].path)
        } else {
          console.log('上传背景失败')
        }
      })
    },
    async getImage(module) {
      await setBook.getImageList({ module: module }).then((res) => {
        if (res.status === 200 && res.data.code === 0) {
          if (module === 'loadPic') {
            this.privateLoadPic = res.data.data
          } else if (module === 'logo') {
            this.privateLogoPic = res.data.data
          } else if (module === 'pcLogo') {
            this.privatePcLogoPic = res.data.data
          }
        } else {
          console.log('获取图片列表失败')
        }
      })
    },
    // 上传logo
    uploadLogoButtonHandler(e) {
      console.log(e)
      // this.getVipInfo()
      if (this.logoDisabled) {
        //   this.$refs.memberDialog.visible = true
        e.preventDefault()
      }
    },
    uploadLoadingLogoButtonHandler(e) {
      this.getVipInfo()
      if (this.loadingLogoDisabled) {
        this.$refs.memberDialog.visible = true
        e.preventDefault()
      }
    },
    uploadAudioButtonHandler(e) {
      this.getVipInfo()
      const res = this.compare({ key: 'bgMusic', type: 'boole' })
      if (!res) {
        this.$refs.memberDialog.visible = true
        e.preventDefault()
      }
    },
    async uploadAudio(e) {
      this.audioFile = e.target.files[0]
      const maxSize = 10 * 1024 * 1024 //最大不能超过10M
      if (this.audioFile.size > maxSize) {
        this.audioFile = null
        this.$alert('上传文件最大不能超过10M', '提示', {
          confirmButtonText: '确定'
        })
        return false
      }
      this.audioFileName = this.audioFile.name
    },
    async bgMusicIsLoop(value) {
      if (!(await this.compareRight({ type: 'boole', key: 'bgMusic' }))) {
        this.$refs.memberDialog.visible = true
        this.circulatePlay = value === 1 ? 0 : 1
      }
    },
    async changeType(value) {
      if (value == 0) {
        if (!(await this.compareRight({ type: 'boole', key: 'replaceBookLogo' })) || !(await this.compareRight({ type: 'boole', key: 'replaceLogoLink' }))) {
          this.$refs.memberDialog.visible = true
          this.logo = 0
        } else {
          this.logo = 1
          this.getImage('logo')
        }
      } else {
        this.logo = 0
        this.logoThumbnail = ''
        this.pcLogo = ''
      }
    },
    changeUrlOpen(value) {
      if (value === 0) {
        this.logoUrl = ''
      } else {
        this.logoUrl = this.$store.state.config.bookObj.logoUrl != '' ? this.$store.state.config.bookObj.logoUrl : `${window.PROJECT_CONFIG.BASE_URL}/elecPublish/`
      }
    },
    getBookMsn() {
      const params = { id: this.getQueryId }
      let detailApi = this.$route.path.indexOf('paper') > -1 ? BookMsn.GetPaperDetails : BookMsn.GetMobileBookDetails
      detailApi(params).then(async (res) => {
        console.log(res)
        const data = res.data.data
        // console.log(data.displayOrNot)
        let loadingPic = data.loadPic !== 'logo.png' ? data.loadPic : ''
        let adornment = data.adornment
        let logo = data.logo
        let logoImg = logo == 'logo.png' ? '' : logo
        let isLogo
        if (this.paperStyle) {
          this.pcLogo = data.pcLogo
          isLogo = data.pcLogo != null
          // '' 设置过，自定义  null 默认
        }
        if ((logoImg || this.pcLogo) && (await this.compare({ type: 'boole', key: 'replaceBookLogo' }))) {
          this.logo = 1
          this.uploadLogo = true
          this.$store.commit('config/UPDATE_LOGOTHUMBNAIL', logoImg)
          this.logoUrlOpen = data.jump != undefined ? data.jump : 1
          this.$store.commit('config/UPDATE_NEWLOGOTHUMBNAIL', logoImg)
          let url = data.url
          let defaultUrl = `${window.PROJECT_CONFIG.BASE_URL}/elecPublish/`
          this.logoUrl = url ? url : defaultUrl
          this.$store.commit('config/UPDATE_LOGOURL', this.logoUrl)
        } else {
          this.logo = 0
          this.logoUrlOpen = 1
        }
        if (loadingPic && (await this.compare({ type: 'boole', key: 'replaceLoadingLogo' }))) {
          this.loadPic = 1
          this.loadTab = true
          this.$store.commit('config/UPDATE_LOADINGPIC', loadingPic)
        } else {
          this.loadPic = 0
        }
        this.soundValue = data.pageSound
        this.voiceNumber = data.voiceNumber
        this.soundOn = data.openSound !== 0
        this.adornment = adornment
        this.longPress = data.longPress
        this.navbarSwtich = data.navbarSwtich
        this.$emit('adornmentMsn', adornment)
        this.readModel = data.readModel
        this.articleLayout = data.articleLayout
        this.articleHighlight = data.articleHighlight
        if (await this.compare({ type: 'boole', key: 'poster' })) {
          this.isPoster = data.poster || 0
          this.selPoster = data.posterStyle || 0
          this.$store.commit('config/UPDATE_POSTER', this.isPoster)
          this.customTit = data.posterTitle || ''
          this.$store.commit('config/UPDATE_POSTERSELECTSTYLE', this.selPoster)
          const customPosterData = {
            posterQrCodeShow: data.posterQrCodeShow === undefined || data.posterQrCodeShow === '' ? 1 : data.posterQrCodeShow,
            posterNameShow: data.posterNameShow === undefined || data.posterNameShow === '' ? 1 : data.posterNameShow,
            posterName: data.posterName || '',
            posterTextShow: data.posterTextShow === undefined || data.posterTextShow === '' ? 1 : data.posterTextShow,
            posterPromptText: data.posterPromptText || '',
            posterCover: data.posterCover ? data.posterCover.split(',') : [],
            posterPic: data.posterPic || 'poster.png'
          }
          this.$store.commit('config/UPDATE_POSTERBOOK', customPosterData)
          this.cusImg = data.posterPic || 'poster.png'
        }
        this.downloadValue = this.lastDownloadValue = data.downloadScope || 0 //赋值是否开放下载
        this.$store.commit('config/UPDATE_DOWNLOADFORMAT', data.downloadFormat)
        this.$store.commit('config/UPDATE_DOWNLOADSCOPE', data.downloadScope)
        this.valuationDownloadStatus(data.downloadFormat)
        const allDownload = this.$store.state.config.allDownload
        this.$store.commit('config/UPDATE_ALLDOWNLOAD', !allDownload)
        const audioData = {
          turnSound: data.openSound,
          bgSound: data.bgMusicSwitch,
          loop: data.bgMusicLoop,
          bgMusic: data.bgMusic
        }
        this.$store.commit('config/UPDATE_AUDIODATA', audioData)
        this.bgMusic = data.bgMusicSwitch || 0
        this.circulatePlay = data.bgMusicLoop || 0
        this.audioFileName = data.bgMusicName
        this.buttonValue = data.buttonStyle
      })
    },
    getDefaultSetting() {
      let currentApi = this.isBaozhi ? paperApi.getDefaultSetting(this.paperObj.id) : getDefaultSetting()
      currentApi.then(async (res) => {
        if (res.data.status === 0 && res.data.data != null) {
          const data = res.data.data
          let loadingPic = data.loadPic !== 'logo.png' ? data.loadPic : ''
          let adornment = data.adornment
          let logo = data.logo
          let logoImg = logo == 'logo.png' ? '' : logo
          if (data.pcLogo) {
            this.pcLogo = data.pcLogo
          }
          if (logoImg && (await this.compare({ type: 'boole', key: 'replaceBookLogo' }))) {
            this.logo = 1
            this.uploadLogo = true
            this.$store.commit('config/UPDATE_LOGOTHUMBNAIL', logoImg)
            this.$store.commit('config/UPDATE_NEWLOGOTHUMBNAIL', logoImg)
          } else {
            this.logo = 0
          }
          if (loadingPic && (await this.compare({ type: 'boole', key: 'replaceLoadingLogo' }))) {
            this.loadPic = 1
            this.loadTab = true
            this.$store.commit('config/UPDATE_LOADINGPIC', loadingPic)
          } else {
            this.loadPic = 0
          }
          this.soundValue = data.pageSound
          this.voiceNumber = data.voiceNumber
          this.soundOn = data.openSound !== 0
          let url = data.url
          let defaultUrl = `${window.PROJECT_CONFIG.BASE_URL}/elecPublish/`
          this.logoUrl = url ? url : defaultUrl
          this.logoUrlOpen = data.jump
          this.longPress = data.longPress
          this.navbarSwtich = data.navbarSwtich
          this.adornment = adornment
          this.$emit('adornmentMsn', adornment)
          this.articleLayout = data.articleLayout
          this.articleHighlight = data.articleHighlight
          if (await this.compare({ type: 'boole', key: 'poster' })) {
            this.isPoster = data.poster || 0
            this.selPoster = data.posterStyle || 0
            this.$store.commit('config/UPDATE_POSTER', this.isPoster)
            this.customTit = data.posterTitle || ''
            this.$store.commit('config/UPDATE_POSTERSELECTSTYLE', this.selPoster)
            const customPosterData = {
              posterQrCodeShow: data.posterQrCodeShow === undefined || data.posterQrCodeShow === '' ? 1 : data.posterQrCodeShow,
              posterNameShow: data.posterNameShow === undefined || data.posterNameShow === '' ? 1 : data.posterNameShow,
              posterName: data.posterName || '',
              posterTextShow: data.posterTextShow === undefined || data.posterTextShow === '' ? 1 : data.posterTextShow,
              posterPromptText: data.posterPromptText || '',
              posterCover: data.posterCover ? data.posterCover.split(',') : [],
              posterPic: data.posterPic || 'poster.png'
            }
            this.$store.commit('config/UPDATE_POSTERBOOK', customPosterData)
            this.cusImg = data.posterPic || 'poster.png'
            this.$store.commit('config/UPDATE_POSTERBG', this.cusImg)
            this.$refs.custompos.bgUrl = this.cusImg
            this.$refs.custompos.styleName = data.posterTitle
            this.$refs.custompos.isShowCode = customPosterData.posterQrCodeShow
            this.$refs.custompos.isShowName = customPosterData.posterNameShow
            this.$refs.custompos.posterName = customPosterData.posterName
            this.$refs.custompos.isShowText = customPosterData.posterTextShow
            this.$refs.custompos.posterPromptText = customPosterData.posterPromptText
            if (customPosterData.posterCover[0] && customPosterData.posterCover[0] != '') {
              this.$refs.custompos.isShowCover = parseInt(customPosterData.posterCover[0])
            }
          }
          const audioData = {
            turnSound: data.openSound,
            bgSound: data.bgMusicSwitch,
            loop: data.bgMusicLoop,
            bgMusic: data.bgMusic
          }
          this.$store.commit('config/UPDATE_AUDIODATA', audioData)
          this.buttonValue = data.buttonStyle
        }
        this.$store.commit('config/UPDATE_LOGOURL', this.logoUrl)
      })
    },
    // 赋值给下载格式
    valuationDownloadStatus(formatStr) {
      this.formatList = []
      const arr = formatStr ? formatStr.split(',') : []
      this.formatList = arr
      if (arr.includes('pdf')) {
        this.pdfStatus = true
      }
      if (arr.includes('zip')) {
        this.zipStatus = true
      }
      if (arr.includes('epub')) {
        this.epubStatus = true
      }
    },
    getCustomTit(val) {
      this.customTit = val
    },
    getCusImg(val) {
      this.cusImg = val
    },
    async handleSelect(e, val) {
      if (val) {
        const isMember = await this.$store.dispatch('common/getVipInfo')
        if (isMember == false) {
          this.$refs.memberDialog.visible = true
          return
        } else {
          e.preventDefault()
          e.stopPropagation()
          this.$nextTick(() => {
            this.$refs.custompos.dialogVisible = true
          })
        }
      }
    },
    async changeDownload() {
      if (this.downloadValue == 1 || this.downloadValue == 2) {
        if (
          !(await this.compareRight({ type: 'boole', key: 'downloadPdf' })) &&
          !(await this.compareRight({ type: 'boole', key: 'downloadHtml' })) &&
          !(await this.compareRight({ type: 'boole', key: 'downloadEpub' }))
        ) {
          this.toMember()
          this.downloadValue = this.lastDownloadValue
          return
        }
      }
      this.lastDownloadValue = this.downloadValue
    },
    async changeDownloadFormat(type) {
      if (this.downloadValue === 0) return
      switch (type) {
        case 'pdf':
          if (this.readModel == 1) return
          if (!(await this.compareRight({ type: 'boole', key: 'downloadPdf' }))) {
            this.toMember()
            return
          }
          this.pdfStatus = !this.pdfStatus
          this.disposeFormat('pdf')
          break
        case 'zip':
          if (!(await this.compareRight({ type: 'boole', key: 'downloadHtml' }))) {
            this.toMember()
            return
          }
          this.zipStatus = !this.zipStatus
          this.disposeFormat('zip')
          break
        case 'epub':
          if (this.readModel == 0) return
          if (!(await this.compareRight({ type: 'boole', key: 'downloadEpub' }))) {
            this.toMember()
            return
          }
          this.epubStatus = !this.epubStatus
          this.disposeFormat('epub')
          break
      }
    },
    disposeFormat(format) {
      const result = this.formatList.findIndex((n) => n == format)
      if (result < 0) {
        this.formatList.push(format)
      } else {
        this.formatList.splice(result, 1)
      }
    },
    async changeBgMusic(val) {
      if (val) {
        if (!(await this.compareRight({ type: 'boole', key: 'bgMusic' }))) {
          this.toMember()
          this.bgMusic = 0
          return
        }
      }
    },
    pauseAudio() {
      if (this.$refs.audio) {
        this.$refs.audio.pause()
      }
    },
    playVoice() {
      this.$refs.audio.src = require(`../../../assets/audios/voice/${this.voiceNumber}.mp3`)
      this.$refs.audio.play()
    },
    delLoadPic(item, e) {
      this.deletePic = item
      this.$refs.deleteDialog.visible = true
    },
    ajustHeight() {
      const h = $('.edit-content').height()
      this.allHeight = h - 232
    },
    deleteCancel() {
      this.$refs.deleteDialog.visible = false
      this.deletePic = null
    },
    deleteConfrim() {
      let module = this.deletePic.module
      setBook.delImage({ ids: this.deletePic.id }).then((res) => {
        if (res.status === 200 && res.data.code === 0) {
          this.getImage(module)
          if (module === 'loadPic') {
            this.loadingPic = ''
            this.loadTab = false
          } else if (module === 'logo') {
            this.logoThumbnail = ''
            this.uploadLogo = false
          }
        } else {
          console.log('删除背景列表失败')
        }
      })
      this.deletePic = null
      this.$refs.deleteDialog.visible = false
    },
    changePclogo(val) {
      this.$store.commit('config/UPDATE_PCLOGO', val)
    }
  },
  components: {
    ButtonSet,
    eleRadio,
    TipDialog,
    LogoCropDialog,
    CustomPos,
    EditAdorn
  },
  mounted() {
    this.$store.dispatch('common/getVipInfo')
    if (!this.isDefault) {
      this.getBookMsn()
      this.ajustHeight()
    } else {
      this.getDefaultSetting()
    }
    this.getImage('loadPic')
    this.getImage('logo')
    this.getImage('pcLogo')
  },
  created() {
    window.addEventListener('resize', this.ajustHeight)
  },
  destroyed() {
    this.pauseAudio()
    this.pcLogo = ''
    this.logoThumbnail = ''
    window.removeEventListener('resize', this.ajustHeight)
  }
}
</script>
<style lang="scss">
.edit-personal {
  user-select: none;
  height: 100%;
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .edit-personal-form {
    padding-bottom: 68px;
  }
  .personal-item {
    display: flex;
    align-items: center;
    margin-top: 18px;
    .el-input {
      &.voice {
        width: 80px;
      }
    }
    &.flex-start {
      align-items: flex-start;
    }
    .read {
      border: none;
      color: #df5813;
      width: 60px;
      padding: 5px 0;
    }
    .tooltips {
      width: 16px;
      height: 16px;
      background-color: #df5813;
      border-radius: 16px;
      color: #ffffff;
      text-align: center;
      line-height: 16px;
      margin-left: 5px;
    }
    .edit-personal-adorn {
      width: 140px;
      .custom-tip {
        padding: 0px 14px;
        line-height: 17px;
        width: 120px;
      }
    }
    &:first-of-type {
      margin-top: 10px;
    }
    .personal-item-title {
      display: inline-block;
      margin-right: 10px;
      font-size: 13px;
      width: 115px !important;
      text-align: right;
      white-space: nowrap;
      line-height: 24px;
    }
    .loading-color {
      width: 90px;
      height: 24px;
      .el-color-picker {
        width: 100%;
        height: 100%;
        .el-color-picker__trigger {
          width: 100%;
          height: 100%;
          padding: 0;
          border: 1px solid #cecece !important;
          .el-color-picker__icon {
            text-align: right;
            padding-right: 10px;
            &.el-icon-arrow-down::before {
              color: #fff;
            }
          }
        }
      }
    }
    .personal-item-select {
      &.el-select {
        width: 90px;
        .el-input {
          .el-input__inner {
            border-color: #cecece;
            height: 24px;
            font-size: 13px;
            padding: 0 5px;
            line-height: 24px;
          }
        }
      }
      .el-icon-arrow-up::before {
        color: #515151;
      }
    }
    .pic-list {
      .el-input__inner {
        padding-right: 10px !important;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
      }
      .el-input__suffix {
        right: 0;
      }
    }
    .uploading {
      height: 100%;
      display: inline-block;
      background: #df5813;
      color: #fff;
      border-radius: 15px;
      border: none;
      width: 55px;
      margin-left: 8px;
      text-align: center;
      line-height: 24px;
    }
    &.loadingText {
      .el-input {
        width: 90px;
        .el-input__inner {
          height: 24px;
          padding: 0 5px;
          font-size: 14px;
        }
      }
    }
    &.price {
      .el-input {
        margin-right: 5px;
        .el-input__inner {
          height: 24px;
          width: 52px;
          padding: 0 5px;
          font-size: 14px;
          text-align: center;
        }
      }
    }
    .personal-item-content {
      display: inline-flex;
    }
    .required {
      color: red;
    }
    &.charge-page {
      .el-input {
        margin: 0 5px;
        .el-input__inner {
          height: 24px;
          width: 36px;
          padding: 0 5px;
          font-size: 14px;
          text-align: center;
        }
      }
    }
    .el-form-item {
      margin-bottom: 0;
      .el-form-item__content {
        margin-left: 0 !important;
        line-height: 24px !important;
        .el-form-item__error {
          white-space: nowrap;
        }
      }
    }
    .upload-tip {
      background-color: #fffaf4 !important;
      color: #515151 !important;
    }
  }
  .padding-63 {
    padding-left: 63px;
  }
  .color-theme {
    align-items: flex-start;
    .personal-item-title {
      height: 30px;
      line-height: 30px;
    }
    .right {
      .right-item {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        .el-color-picker {
          width: 85px;
          height: 30px;
          .el-color-picker__trigger {
            width: 100%;
            height: 100%;
            padding: 0;
            border-radius: 10px;
            .el-color-picker__color {
              border-radius: 10px;
              .el-color-picker__color-inner {
                border-radius: 10px;
              }
            }
          }
        }
        .el-input {
          width: 85px;
          height: 30px;
        }
      }
    }
  }
  .checkUrl {
    align-items: flex-start;
    .personal-item-title {
      width: 90px;
    }
    .right {
      /*width: 136px;*/
      .el-input {
        .el-input__inner {
          border-color: #cecece;
          height: 24px;
          font-size: 14px;
          padding: 0 5px;
          line-height: 24px;
        }
      }
      .logoArea {
        img {
          width: 107px;
        }
        .uploadlogo {
          .uploadlogoButton {
            width: 55px;
            height: 24px;
            background: #df5813;
            color: #fff;
            border-radius: 15px;
            font-size: 14px;
            display: inline-flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            margin: 10px 0 0 8px;
            cursor: pointer;
          }
          .thumbnail {
            width: 120px;
            height: 35px;
            background: rgba(0, 0, 0, 0.6);
            color: #fff;
            margin-top: 5px;
            p {
              width: 100%;
              text-align: center;
              font-size: 14px;
              margin: 0;
              line-height: 17px;
            }
            img {
              width: 100%;
              height: 100%;
            }
          }
          .logoUrlTxt {
            margin: 5px 0;
            font-size: 14px;
          }
        }
      }
    }
    .loadPic {
      width: 90px;
    }
  }
  .poster {
    .right {
      .el-select {
        width: 136px !important;
      }
    }
  }
  .long-press {
    .right {
      .el-select {
        width: 136px !important;
      }
    }
  }
  .posterStyle {
    align-items: flex-start;
    .right {
      .el-select {
        width: 136px !important;
      }
      .customSec {
        margin-top: 6px;
        height: 26px;
        display: flex;
        line-height: 26px;
        justify-content: space-between;
        button {
          width: 60px;
          cursor: pointer;
          background: #df5813;
          border: none;
          color: #fff;
        }
        .customTit {
          width: 70px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .uploadAudioBut {
          width: 26px;
          height: 26px;
          border: 1px solid #dcdfe6;
          display: -webkit-flex;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          img {
            width: 10px;
          }
        }
        .audio-name {
          width: 103px;
          color: #515151;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .loadPic {
    overflow: hidden;
    align-items: flex-start;
    .loadingSelect {
      display: flex;
      align-items: center;
      height: 24px;
      margin-bottom: 5px;
    }
    .thumbnail {
      width: 120px;
      height: 35px;
      background: rgba(0, 0, 0, 0.6);
      color: #fff;
      margin-top: 5px;
      p {
        width: 100%;
        text-align: center;
        font-size: 14px;
        margin: 0;
        line-height: 17px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .inputTime {
    width: 124px;
  }
  .openDownload {
    align-items: flex-start;
    .right {
      .el-select {
        width: 136px !important;
      }
    }
    .downloadSel {
      padding-top: 10px;
      display: -webkit-flex;
      display: flex;
      justify-content: space-between;
      .species {
        display: -webkit-flex;
        display: flex;
        > span {
          font-size: 12px;
          margin-left: 3px;
          line-height: 14px;
        }
      }
    }
  }
  .personal-vip-title {
    height: 24px;
    span {
      height: 100%;
      line-height: 24px;
    }
    img {
      height: 24px;
      float: right;
      margin-left: 1px;
    }
    i {
      width: 30px;
      line-height: 20px;
      background: #df5813;
      text-align: center;
      color: #fff;
      font-size: 10px;
      margin-left: 5px;
      border-radius: 2px;
      font-style: normal;
      font-weight: bold;
    }
  }
  .winEffect {
    .right {
      .el-select {
        width: 136px !important;
      }
    }
  }
}
.default_edit-personal {
  .el-scrollbar {
    .edit-personal-form {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      padding-bottom: 20px;
      height: 650px;
      .default-poster {
        /*height: 100px;*/
      }
      font-size: 13px;
      &.showDownload {
        //height: 280px;
      }
    }
  }
}
.el-select-dropdown {
  .el-scrollbar {
    .pic-list-item {
      width: 100px;
      padding: 0 0 0 10px;
      position: relative;
      .select-del {
        display: none;
        position: absolute;
        right: 5px;
        top: 7px;
        background: rgba(0, 0, 0, 0.5);
        width: 18px;
      }
      &:hover {
        padding-right: 30px;
        .select-del {
          display: inline-block;
        }
      }
    }
  }
}
</style>
